import React from 'react';
import styles from './DateInput.module.scss';
import { isNullOrUndefined } from '../../../helpers/object-helpers';

export interface IDateInput {
  id: string;
  label: string;
  placeholder?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isValid?: boolean;
  value: string;
  isWide?: boolean;
  maxLength?: number;
}

export default function DateInput({
  id,
  label,
  placeholder,
  onChange,
  disabled,
  isValid,
  value = '',
  isWide = false,
  maxLength = 2,
}: IDateInput) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onChange != null) onChange(event.target.value);
  }

  function getInputClasses() {
    let classes = isWide ? ` ${styles.wideInput}` : '';

    if (isNullOrUndefined(isValid)) return classes;

    classes += isValid ? ` ${styles.validInput}` : ` ${styles.invalidInput}`;

    return classes;
  }

  const inputClasses = getInputClasses();

  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={styles.inputContainer}>
        <input
          id={id}
          type="text"
          placeholder={placeholder}
          aria-invalid={isValid !== null ? isValid === false : undefined}
          disabled={disabled}
          autoComplete="off"
          onChange={handleChange}
          value={value}
          className={inputClasses}
          maxLength={maxLength}
          inputMode="numeric"
        />
      </div>
    </div>
  );
}
